import { render } from "./HomeCarousel.vue?vue&type=template&id=6cf8f91a&scoped=true"
import script from "./HomeCarousel.vue?vue&type=script&lang=js"
export * from "./HomeCarousel.vue?vue&type=script&lang=js"

import "./HomeCarousel.vue?vue&type=style&index=0&id=6cf8f91a&scoped=true&lang=scss"

import exportComponent from "D:\\wjm\\offical-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf8f91a"]])

export default __exports__